import type { ExtendedUserInfo } from "../authentication";
import { useAuthentication } from "@services/auth";
import { PermissionsApp } from "./authorization-service-impl";

export function usePermissionCheckers(userInfo?: ExtendedUserInfo) {
    const auth = useAuthentication();
    
    // Función interna para obtener la información del usuario
    const getUserInfo = (): ExtendedUserInfo => {
        return userInfo || (auth.userInfo as ExtendedUserInfo);
    };
    
    // Función interna para verificar permisos
    const hasPermission = (permission: string): boolean => {
        const info = getUserInfo();
        return info.permissions?.has(permission) || false;
    };
    
    // Funciones de verificación de permisos específicos
    const canAccessOperacionesEnergia = () => 
        hasPermission(PermissionsApp.ViewOperaciones);
    
    return {
        canAccessOperacionesEnergia,
    };
}